"use client";

import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from "@/components/ui/sheet";
import { ChevronDown } from "lucide-react";
import { navigationItems } from "./Navbar";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export function MobileMenu() {
  const pathname = usePathname();
  const page = pathname.split("/").slice(0, 2)[1];
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <Sheet open={open} onOpenChange={(state) => setOpen(state)}>
      <SheetTrigger asChild>
        <Button className="rounded-full border border-black/8 bg-white/70 pr-2 text-slate-900/80 shadow-none backdrop-blur-sm transition hover:bg-white/85 hover:text-slate-950 dark:border-white/10 dark:bg-[#0b0b0f]/70 dark:text-white/80 dark:hover:bg-[#15151b] dark:hover:text-white">
          <span className="pr-1">
            {pathname === "/" ? "Home" : page[0].toUpperCase() + page.slice(1)}
          </span>
          <ChevronDown size={15} />
        </Button>
      </SheetTrigger>
      <SheetContent
        className="mt-10 ml-6 mr-10 rounded-2xl border border-stone-900/10 bg-stone-100/88 text-slate-950 shadow-none backdrop-blur-md dark:border-white/10 dark:bg-[#0b0b0f]/88 dark:text-white/80"
        side="top"
      >
        <ul className="mt-5 flex flex-col space-y-1 px-3 pb-2">
          {navigationItems.map((item, index) => {
            const isActive = pathname === item.href;

            return (
              <li key={index}>
                <Link
                  href={item.href}
                  className={cn(
                    "flex items-center rounded-xl px-3 py-3 transition",
                    isActive
                      ? "bg-black/6 font-semibold text-slate-950 dark:bg-white/10 dark:text-white"
                      : "text-slate-800 hover:bg-black/6 hover:text-slate-950 dark:text-white/70 dark:hover:bg-white/8 dark:hover:text-white"
                  )}
                >
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
